import axios from "axios";
import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";

function App() {
  const [page, setPage] = useState(0);
  const [description, setDescription] = useState("");
  const [structure, setStructure] = useState("");
  const [state, setState] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const sendEmail = async () => {
    const body = {
      description,
      structure,
      state,
      name,
      email,
      phone,
    }

    axios.post('https://tudoincendio.ateny.space/api/orcamentos', body)
  }
  useEffect(() => {
    console.log(page);
  }, [page]);

  function progress(page) {
    if (page === 0) {
      return "25%";
    } else if (page === 1) {
      return "50%";
    } else if (page === 2) {
      return "75%";
    } else {
      return "100%";
    }
  }

  return (
    <div>
      <form
        className={`container max-w-2xl mx-auto shadow-md md:w-3/4 relative h-[450px]`}
        style={{ display: page === 5 ? "none" : "block" }}
      >
        <div>
          <div className="p-4 bg-gray-100 border-t-2 border-red-400 rounded-lg bg-opacity-5">
            <div className="mx-auto md:w-full md:mx-0">
              <div className="w-full rounded-full h-2.5 mb-4 bg-gray-700">
                <div
                  className="bg-red-600 h-2.5 rounded-full"
                  style={{ width: progress(page) }}
                ></div>
              </div>
            </div>
          </div>
          <div className=" bg-white">
            <h1 className="text-2xl text-center pt-3">
              Nos descreva o que você está buscando
            </h1>
            <div className="text-gray-400 text-center mt-1 pb-5">
              {page === 3 &&
                "Deixe os seus dados para que a gente possa retornar."}
            </div>
          </div>
        </div>
        <div className="space-y-6 bg-white">
          {/* Página 1 */}
          <div
            className={`${page !== 0 ? "hidden" : "block"
              } items-center w-full p-4 space-y-4 text-gray-500  md:space-y-0`}
          >
            <label className="text-gray-700" htmlFor="name"></label>
            <textarea
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              className="flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent"
              id="comment"
              placeholder="Digite aqui"
              name="comment"
              rows={5}
              cols={40}
            />
          </div>

          {/* Página 2 */}
          <div
            className={`${page !== 1 ? "hidden" : "md:inline-flex"
              } justify-center items-center w-full p-3  `}
            style={{ marginTop: -10, marginBottom: 10 }}
          >
            <div className="w-96">
              <h2 className="text-xl font-semibold">
                Qual o tipo da estrutura?
              </h2>
              <div className="flex items-center pb-4 pt-5"
                onClick={() => {
                  setStructure("Comercial")
                }}
              >
                <input
                  id="default-radio-1"
                  type="radio"
                  value=""
                  name="default-radio"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 "
                />
                <label
                  for="default-radio-1"
                  className="ml-2 text-lg font-medium text-gray-900 "
                >
                  Comercial
                </label>
              </div>
              <div className="flex items-center pb-4 "
                onClick={() => {
                  setStructure("Industrial")
                }}
              >
                <input
                  id="default-radio-3"
                  type="radio"
                  value=""
                  name="default-radio"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 "
                />
                <label
                  for="default-radio-3"
                  className="ml-2 text-lg font-medium text-gray-900 "
                >
                  Industrial
                </label>
              </div>
              <div className="flex items-center"
                onClick={() => {
                  setStructure("Residencial")
                }}
              >
                <input
                  id="default-radio-2"
                  type="radio"
                  value=""
                  name="default-radio"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 "
                />
                <label
                  for="default-radio-2"
                  className="ml-2 text-lg font-medium text-gray-900 "
                >
                  Residencial
                </label>
              </div>
            </div>
          </div>

          {/* Página 3 */}
          <div
            className={`${page !== 2 ? "hidden" : "block"
              } items-center w-full p-4 space-y-4 text-gray-500  md:space-y-0`}
          >
            <label
              for="countries"
              className="block mb-2 text-xl font-semibold text-gray-900"
            >
              Selecione o seu estado
            </label>
            <select
              id="countries"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              name="states"
              onChange={(e) => {
                setState(e.target.value)
              }}
              value={state}
            >
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espírito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MT">Mato Grosso</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
            </select>
          </div>

          {/* Página 4 */}
          <div
            className={`${page !== 3 ? "hidden" : "block"
              } items-center w-full p-4 space-y-4 text-gray-500  md:space-y-0`}
            style={{ marginTop: -10 }}
          >
            <div className="w-full space-y-6">
              <div className="w-full">
                <div className=" relative ">
                  <input
                    type="text"
                    id="search-form-price"
                    className=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent"
                    placeholder="Nome"
                    onChange={(e) => {
                      setName(e.target.value)
                    }}
                    value={name}
                  />
                </div>
              </div>
              <div className="w-full">
                <div className=" relative ">
                  <InputMask mask="(99) 99999-9999"
                    onChange={(e) => {
                      setPhone(e.target.value)
                    }}
                    value={phone}
                  >
                    {() => (
                      <input
                        type="text"
                        id="search-form-location"
                        className=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent"
                        placeholder="Celular"
                      />
                    )}
                  </InputMask>
                </div>
              </div>
              <div className="w-full">
                <div className=" relative ">
                  <input
                    type="text"
                    id="search-form-name"
                    className=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent"
                    placeholder="Email"
                    onChange={(e) => {
                      setEmail(e.target.value)
                    }}
                    value={email}
                  />
                </div>
              </div>
            </div>
          </div>

          {/*  Botões */}
          <div className="w-full py-6 px-4 pb-4 ml-auto  md:w-1/3">
            <div className={page > 0 ? "block" : "hidden"}>
              <button
                onClick={(e) => {
                  setPage(page - 1);
                  e.preventDefault();
                }}
                className="absolute left-6 bottom-3 py-1 px-4 text-red-500 transition ease-in duration-200 rounded-lg hover:bg-red-600 w-36 hover:text-white border-2 border-red-500 focus:outline-none font-semibold"
              >
                Anterior
              </button>
            </div>
            <div className={page >= 3 ? "hidden" : "block"}>
              <button
                onClick={(e) => {
                  setPage(page + 1);
                  e.preventDefault();
                }}
                className="absolute right-6 bottom-3 py-2 px-4 bg-red-600 hover:bg-red-700 focus:ring-red-500 focus:ring-offset-blue-200 text-white w-36 transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "
              >
                Próximo
              </button>
            </div>
            <div>
              <button
                // type="submit"
                onClick={(e) => {
                  setPage(5);
                  e.preventDefault();
                  sendEmail();
                }}
                className={`${page >= 3 ? "block" : "hidden"
                  } absolute right-6 bottom-3 py-2 px-4 bg-red-600 hover:bg-red-700 focus:ring-red-500 focus:ring-offset-blue-200 text-white w-36 transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg`}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      </form>

      <div className={page !== 5 ? "hidden" : "block"}>
        <div className="flex items-center justify-center h-screen">
          <div>
            <div className="flex flex-col items-center space-y-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-green-600 w-28 h-28"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h1 className="text-4xl font-bold">Obrigado !</h1>
              <p>Entraremos em contado em breve.</p>
              {/* <a
                href="/"
                className="inline-flex items-center px-4 py-2 text-white bg-red-600 border border-red-600 rounded rounded-full hover:bg-red-700 focus:outline-none focus:ring"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 16l-4-4m0 0l4-4m-4 4h18"
                  />
                </svg>
                <span className="text-sm font-medium">Página inicial</span>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
